import React,{useState} from 'react';
import {Button, Menu, MenuItem, ListItemIcon, Typography} from '@material-ui/core/';
import { useStyles } from "./style";

export default function SimpleMenu(props) {
	const [anchorEl, setAnchorEl] = useState(null),
	classes = useStyles(),
	handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	},
	handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<div>
			{
				(props.showButtonSimple) ?(
					<Button  size="large" className={classes.buttonSimple} onClick={handleClick}>
						Menú
					</Button>
				):(
					<Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} variant="contained" className={classes.bottonNormal} >
						Menú
					</Button>
				)
			}
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{
					props.arrayMenuDesplegable.map((button) => {
						return(
							// <MenuItem onClick={button.customFunctionTable}>{button.customTitleButtonTable}</MenuItem>
							<MenuItem onClick={button.customFunctionTable}>
							    <ListItemIcon className={classes.iconColor}>
            						{button.customIconButtonTable}
								</ListItemIcon>
								<Typography className={classes.textColor} variant="inherit">{button.customTitleButtonTable}</Typography>
							</MenuItem>
						)
					})
				}
			</Menu>
		</div>
	);
}